export class POCodesModel {
    item_code: string
    item_desc: string
    code_type: number
    code_no: number
    vendor: string
    vendor_code: string
    manufacturer_code: string

    private _header: string

    public get header(): string {
        return `${this.item_code} -- ${this.item_desc}${this.code_type === 1 ? ' (I)' : ' (W)'}`;
    }

    public set header(header: string) {
        this._header = header;
    }

    constructor(
        item_code: string,
        item_desc: string,
        code_type: number,
        code_no: number,
        vendor: string,
        vendor_code: string,
        manufacturer_code: string
    ) {
        this.item_code = item_code
        this.item_desc = item_desc
        this.code_type = code_type
        this.code_no = code_no
        this.vendor = vendor
        this.vendor_code = vendor_code
        this.manufacturer_code = manufacturer_code
    }
}

export class POItemCodesModel {
    code_name: string
    code_no: number
    code_type: number
    order_code: string
    order_no: number
    container_cost: number
    qty: number
    vendor_code: string

    constructor(
        code_name: string,
        code_no: number,
        code_type: number,
        order_code: string,
        order_no: number,
        container_cost: number,
        qty: number,
        vendor_code: string
    ) {
        this.code_name = code_name
        this.code_no = code_no
        this.code_type = code_type
        this.order_code = order_code
        this.order_no = order_no
        this.container_cost = container_cost
        this.qty = qty
        this.vendor_code = vendor_code
    }
}